import { render, staticRenderFns } from "./ss-right-menu.vue?vue&type=template&id=10d579f4&scoped=true&"
import script from "./ss-right-menu.vue?vue&type=script&lang=js&"
export * from "./ss-right-menu.vue?vue&type=script&lang=js&"
import style0 from "./ss-right-menu.vue?vue&type=style&index=0&id=10d579f4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d579f4",
  null
  
)

export default component.exports